class CSVInvitation {
  declare _existingInvitationCount: number;

  declare _invitationCount: number;

  declare _skippedMemberCount: number;

  declare _fileUrl?: string;

  declare _invalidExternalIds: string[];

  declare _inviteesWithInvalidEmail: string[];

  declare _inviteesWithInvalidExternalId: string[];

  declare _inviteesWithInvalidNames: string[];

  constructor({
    apiData = {},
  }: {
    apiData?: {
      existingInvitationCount?: number;
      invitationCount?: number;
      skippedManagerCount?: number;
      skippedMemberCount?: number;
      fileUrl?: string;
      inviteesWithInvalidExternalId?: string[];
      inviteesWithInvalidEmails?: string[];
      inviteesWithInvalidEmail?: string[];
      inviteesWithInvalidNames?: string[];
    };
  }) {
    this._existingInvitationCount = apiData.existingInvitationCount || 0;
    this._invitationCount = apiData.invitationCount || 0;
    this._skippedMemberCount = apiData.skippedMemberCount || 0;
    this._fileUrl = apiData.fileUrl;
    this._invalidExternalIds = apiData.inviteesWithInvalidExternalId || [];
    this._inviteesWithInvalidEmail = apiData.inviteesWithInvalidEmails || apiData.inviteesWithInvalidEmail || [];
    this._inviteesWithInvalidExternalId = apiData.inviteesWithInvalidExternalId || [];
    this._inviteesWithInvalidNames = apiData.inviteesWithInvalidNames || [];
  }

  get invitationCount() {
    return this._invitationCount;
  }

  get totalSkippedCount() {
    return (
      this._skippedMemberCount +
      this._inviteesWithInvalidEmail.length +
      this._inviteesWithInvalidNames.length +
      this._invalidExternalIds.length +
      this._existingInvitationCount
    );
  }
}

export default CSVInvitation;
